import { Injectable } from "@angular/core";
import { BaseRepository } from "./base.repository";
import { TokenHttp } from "../services/tokenhttp.service";
import { Observable } from "rxjs";
import { IProduct } from "../interfaces/IProduct";
import { IErpProduct } from "../interfaces/IErpProduct";

@Injectable()
export class ProductRepository extends BaseRepository {

    constructor(tokenHttp: TokenHttp) { 
        super(tokenHttp);
    }

    public getAll(): Observable<IProduct[]> {
        return this.mapGet("products/getall");
    }

    public getAllErpProducts(): Observable<IErpProduct[]> {
        return this.mapGet("products/getall/erp");
    }

    public syncErpProducts(): Observable<boolean> {
        return this.mapGet("products/sync-erp")
    }

    public updateProductErp(dto: any): Observable<boolean> {
        return this.mapPost("products/save-erp", dto)
    }
}